import Vision from '../pages/vision';
import Home from './home';
import Mission from './mission';
import Team from './team';
import Contact from './contact';
// import Doctrine from './doctrine';
import {
    BrowserRouter as Router,
    Routes,
    Route,
} from 'react-router-dom';
import Header from './uiComponents/header';
import Footer from './uiComponents/footer';
import NotFound from './notFound';
import ScrollRedirect from './uiComponents/scrollRedirect';
import PrivacyPolicy from './privacyPolicy';
import Bible from './bible/Bible';

const Dashboard = () => {

    return (
        <Router>
            <Routes>
                <Route path="/" element={
                    <>
                        <Header />
                        <Home />
                    </>
                } />
                <Route path="/vision" element={
                    <>
                        <Header />
                        <Vision />
                    </>
                } />
                <Route path="/mission" element={
                    <>
                        <Header />
                        <Mission />
                    </>
                } />
                <Route path="/team" element={
                    <>
                        <Header />
                        <Team />
                    </>
                } />
                <Route path="/contact" element={
                    <>
                        <Header />
                        <Contact />
                    </>
                } />
                <Route path="/privacy" element={
                    <>
                        <Header />
                        <PrivacyPolicy />
                    </>
                } />
                <Route path="/about" element={
                    <>
                        <Header />
                        <ScrollRedirect targetId="about" />
                    </>
                } />
                <Route path="/location" element={
                    <>
                        <Header />
                        <ScrollRedirect targetId="location" />
                    </>
                } />
                <Route path="*" element={
                    <>
                        <Header />
                        <NotFound />
                    </>
                } />
                <Route path="/bible" element={<Bible />} />
            </Routes>
            <Footer />
        </Router>

    );
}

export default Dashboard;